import React from 'react'

function WarningIcon(): JSX.Element {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        // eslint-disable-next-line max-len
        d="M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30ZM13.5 8.25H16.5V17.25H13.5V8.25ZM14.9999 21.75C15.8284 21.75 16.4999 21.0784 16.4999 20.25C16.4999 19.4216 15.8284 18.75 14.9999 18.75C14.1715 18.75 13.4999 19.4216 13.4999 20.25C13.4999 21.0784 14.1715 21.75 14.9999 21.75Z"
        fill="#F8CA44"
      />
    </svg>

  )
}

export default WarningIcon
